<button [disabled]="disabled" [ngClass]="{
        'primary': variant === 'primary',
        'secondary': variant === 'secondary',
        'size-sm': size === 'sm',
        'size-full': size === 'full'
    }">
  {{ title }}
</button>
